import { DeviceRobot } from "src/models/device";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DeviceRobotEntityModel = createEntityModel<DeviceRobot>(
  (robot) => robot.robotId
);
